import Select, { components } from 'react-select';
import { withCssModulesClassNames } from '../../../common/nextMigrationHelpers';

// eslint-disable-next-line import/no-named-default
import { default as styles } from '../../../scss/components/StyleSelectorDropdown.module.scss';

import { ProductStyleCMS } from './types';

const cssModulesClassNames = withCssModulesClassNames(styles);

const Option: typeof components.Option = (props) => {
  const {
    label,
    data: { iconUrl },
  } = props;

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <components.Option {...props}>
      <div>
        <img src={iconUrl} alt="" />
      </div>
      <span>{label}</span>
    </components.Option>
  );
};

interface OptionType {
  label: string;
  value: string;
  iconUrl?: string;
}

export interface StyleSelectorDropdownProps {
  activeStyle?: ProductStyleCMS | null;
  onSelect: (styleId: ProductStyleCMS['id']) => void;
  options: OptionType[];
}

const StyleSelectorDropdown = ({
  onSelect,
  options,
  activeStyle,
}: StyleSelectorDropdownProps) => {
  const sameAsActive = (option: OptionType) => option.value === activeStyle?.id;
  const value = options.find(sameAsActive);

  return (
    <div className={cssModulesClassNames('react-select__container')}>
      <Select<OptionType>
        classNamePrefix={'react-select'}
        instanceId="style-selector-dropdown"
        onChange={(option) => option && !sameAsActive(option) && onSelect(option.value)}
        value={value}
        options={options}
        components={{
          IndicatorSeparator: () => null,
          Option,
        }}
        isSearchable={false}
      />
    </div>
  );
};

export default StyleSelectorDropdown;
